<script setup lang="ts">
const { type = 'info' } = defineProps<{
  type?: 'success' | 'error' | 'warn' | 'info' | 'default'
}>()

const getIcon = (type) => {
  switch (type) {
    case 'success':
      return 'icon:success'
    default:
      return 'icon:warning'
  }
}
</script>

<template>
  <p
    :class="`message message--${type}`"
    :aria-live="type === 'error' || type === 'warn' ? 'assertive' : 'polite'"
  >
    <NuxtIcon
      :name="getIcon(type)"
    />
    <span class="message__text">
      <slot />
    </span>
  </p>
</template>

<style>
@import url("~layers/components/Ui/Message.css");
</style>
